import slug from './slug';
var locationToString = function locationToString(location) {
  if (!location || (location == null ? void 0 : location.locationError) || !(location == null ? void 0 : location.zipCodeCity) || !(location == null ? void 0 : location.zipCodeState)) {
    return undefined;
  }
  return "".concat(slug(location.zipCodeCity), ":").concat(location.zipCodeState.toUpperCase());
};
export default locationToString;